import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
// import firebase from 'firebase';
import * as firebaseui from 'firebaseui';
import { createUser, User } from 'src/app/d3/models/user';
import APP_CONFIG from '../../app.config'
import { UserdataService } from '../user/userdata.service';
import { Auth, getAuth, AuthCredential, UserCredential, GoogleAuthProvider, TwitterAuthProvider, FacebookAuthProvider } from 'firebase/auth';
import * as firebase from 'firebase/compat';

@Injectable({
  providedIn: 'root'
})
export class AuthenticateService {
  private fbUI? : firebaseui.auth.AuthUI;
  private uiConfig?: firebaseui.auth.Config;
  private session_name = APP_CONFIG.APPLICATION.AUTH.SESSION_NAME;
  private redirectAuthTo = APP_CONFIG.APPLICATION.AUTH.REDIRECT_PATH;
  private readonly redirectToParam = APP_CONFIG.APPLICATION.URL.PARAMS.REDIRECT_TO;
  private user?: User;
  private firebaseAuth: Auth = getAuth();

  // Consolidate: authService + userDataService

  constructor(public router: Router, 
    private userDataService: UserdataService) {}

  initAuth() {
    this.setRedirectPath();
    this.setConfig();

    if(! this.firebaseAuth) {
      this.firebaseAuth = getAuth(); //firebase.auth();
    }
    if(! this.fbUI) {
      this.fbUI = new firebaseui.auth.AuthUI(this.firebaseAuth);
    }
  }

  /**
   * Determins if user is authenticated.
   * @returns boolean
   */
  isAuth(): boolean {
    // Check local storage
    var sessionData = this.userDataService.localData$.getValue();
    if(!! sessionData) {
      return true
    }

    return false;
  }

  execAuth() {
     //Authenticate
    this.initAuth();

    if(!this.fbUI || !this.uiConfig) {
      console.error(`Failed to starts auth due to error: fbUi=${!!this.fbUI} uiConfig=${!!this.uiConfig}`);
      return;
    }
    
    if(this.fbUI && ! this.firebaseAuth.currentUser) {
      this.fbUI.start('#firebaseui-auth-container', this.uiConfig);
    } else {
      console.log('Current User', this.firebaseAuth.currentUser);
      this.fbUI.reset();
      return true;
    }
    
    return false
  }

  invalidateAuth(): boolean{
    this.userDataService.removeLocalData();
    this.firebaseAuth.signOut()
    return this.isAuth();
  }

  setConfig() {
    var that = this;
    this.uiConfig = {
      callbacks: {
        // TODO: should fix in the future 
        // https://github.com/firebase/firebaseui-web/issues/813
        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
          console.log("Sign in successful: ", authResult, redirectUrl)
          that.setAuthDetails(authResult);
          return true;
        },
        uiShown: function() {
          let loaderElement = document.getElementById("loader");
          if(!loaderElement || loaderElement.style.display) return;
          loaderElement.style.display = 'none';
        }
      },

      signInFlow: 'popup',
      signInSuccessUrl: that.redirectAuthTo,
      signInOptions: [
        GoogleAuthProvider.PROVIDER_ID,
        TwitterAuthProvider.PROVIDER_ID,
        FacebookAuthProvider.PROVIDER_ID
      ],

      //Terms of service
      //tosUrl: '/terms-of-service',

      //Privacy policy
      // privacyPolicyUrl: '/privacy-policy'
    }
  }

  defaultSuccessfulSignInResult(authResul: any, redirectUrl: string) {}

  setAuthDetails(creds: UserCredential) {
    this.user = createUser(creds);
    if(!this.user) {
      console.error('User data not found');
      return;
    }
    this.userDataService.syncUserData(this.user);
  }

  setRedirectPath(): string {
    let currentUrl : UrlTree = this.router.parseUrl(this.router.url);
    
    if (!! currentUrl.queryParams[this.redirectToParam]) {
      this.redirectAuthTo = currentUrl.queryParams[this.redirectToParam];
    }

    return this.redirectAuthTo;
  }
}
